/* custom-palo: Instagram links inside the Instagram / Facebook in-app browsers.
   There, ig.me and instagram.com links open a signed-out web view, so we open the
   Instagram app profile (instagram://) in the same window instead, and fall back to
   the instagram.com profile after ~1.5 s if the page is still visible.
   Everywhere else the links are left untouched (ig.me DM link, new tab). */
(function () {
  var ua = navigator.userAgent || '';
  if (!/Instagram|FBAN|FBAV/i.test(ua)) return;
  var APP = 'instagram://user?username=atelierdeslacs_';
  var WEB = 'https://www.instagram.com/atelierdeslacs_/';
  var SELECTOR = 'a[data-palo-ig], a[href*="ig.me/m/atelierdeslacs_" i], a[href*="instagram.com/atelierdeslacs_" i]';

  function open(e) {
    e.preventDefault();
    var timer = setTimeout(function () {
      if (!document.hidden) window.location.href = WEB;
    }, 1500);
    var cancel = function () { if (document.hidden) clearTimeout(timer); };
    document.addEventListener('visibilitychange', cancel);
    window.addEventListener('pagehide', function () { clearTimeout(timer); }, { once: true });
    window.location.href = APP;
  }

  function fix(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (a) {
      if (a.dataset.paloIgFixed) return;
      a.dataset.paloIgFixed = '1';
      a.removeAttribute('target');
      a.setAttribute('href', APP);
      a.addEventListener('click', open);
    });
  }

  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', function () { fix(); });
})();
